module.exports = __webpack_public_path__ + "static/media/26.93c4d7f7.jpg";